module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKBAMAAABPkMOvAAAAG1BMVEUAAABFR0pFRkpFR0lGTU1ERkpESU1GSkpERklN6vXGAAAACHRSTlMAZ2HiIeE4N3fGA7IAAABASURBVAjXYyhVYAACJjMGiyYQQ6OZQaJDASjQ0cjA2NEEFOgQYAAJgQQYQEJgAZAQSAAsBBIACwEFwIDFAUgAAIf3DQb+y4ODAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = w80D
// module chunks = 3